import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/common/language.png'
import _imports_1 from '../../assets/images/common/cart.png'
import _imports_2 from '../../assets/images/common/white_cart.png'
import _imports_3 from '../../assets/images/common/navigator.png'


const _withScopeId = n => (_pushScopeId("data-v-a1752b96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%","height":"100%"} }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "right flexCenter" }
const _hoisted_4 = {
  key: 0,
  class: "cart",
  src: _imports_1
}
const _hoisted_5 = {
  key: 1,
  class: "cart",
  src: _imports_2
}
const _hoisted_6 = {
  key: 2,
  class: "numberout flexCenter"
}
const _hoisted_7 = { class: "number" }
const _hoisted_8 = {
  key: 0,
  class: "topContainer",
  style: {"background":"rgba(0,0,0, 0.5)","z-index":"-1"}
}
const _hoisted_9 = { class: "inner" }
const _hoisted_10 = { class: "main" }
const _hoisted_11 = {
  class: "commonFont",
  style: {"margin-top":"16px","padding-left":"15px","margin-bottom":"5px","color":"#000000","font-weight":"500"}
}
const _hoisted_12 = ["onClick"]

import { useRouter } from "vue-router";
import { onMounted, reactive, ref, getCurrentInstance, onBeforeUnmount } from "vue";
import { get, post } from "../../utils/request";

export default /*#__PURE__*/_defineComponent({
  __name: 'TopHeader',
  props: ["title", "background", "backPop"],
  setup(__props) {

const props = __props;

const router = useRouter();

const { proxy } = getCurrentInstance();
const { locale, t } = proxy.$useI18n();
const isOpen = ref(false);
const showDeleteDialog = ref(false);
const bk = ref();
const backPop = ref(false);
const mineList = reactive([
	{
		name: t("message.mine.mine1"),
		url: "/mineOrder",
	},
	{
		name: t("message.mine.mine2"),
		url: "/account",
	},
	{
		name: t("message.mine.mine3"),
		url: "/address",
	},
	{
		name: t("message.mine.mine4"),
		url: "/support",
	},
	{
		name: t("message.mine.mine5"),
		url: "logout",
	},
]);
const cartNumber = ref();
const phone = ref();
const goLanguage = () => {
	router.push("/language");
};
const goCart = () => {
	let storage = localStorage.getItem("access_token");
	if (!storage) {
		router.push("/login");
	} else {
		router.push("/shopCart");
	}
};
const navigateOut = () => {
	let storage = localStorage.getItem("access_token");
	if (!storage) {
		router.push("/login");
	} else {
		isOpen.value = true;
	}
};
const goHome = () => {
	router.push("/shopHome");
};
const close = () => {
	isOpen.value = false;
};
const go = (item) => {
	if (item.url == "logout") {
		showDeleteDialog.value = true;
		return;
	}
	isOpen.value = false;
	router.push(item.url);
};
const getNumber = () => {
	let storage = localStorage.getItem("access_token");
	if (storage) {
		get("/api-bape/shop/cart/count", {}, false, false).then((res) => {
			if (res.code == 1) {
				cartNumber.value = res.result.count;
			}
		});
	}
};
const logout = () => {
	post("/api-bape/user/logout").then((res) => {
		if (res.code == 1) {
			router.push("/login");
			showDeleteDialog.value = false;
			localStorage.removeItem("access_token");
			router.replace("/login");
		}
	});
};
onMounted(() => {
	bk.value = props.background;
	backPop.value = props.backPop;
	phone.value = localStorage.getItem("phone");
	getNumber();
	proxy.$mitt.on("updateCart", () => {
		getNumber();
	});
	if (window.location.href.includes("shopHome")) {
		const scrollView = document.querySelector(".routerView");
		const handleScroll = () => {
			if (scrollView.scrollTop > 200) {
				bk.value = "back";
			} else {
				bk.value = "";
			}
		};
		scrollView.addEventListener("scroll", handleScroll);
		onBeforeUnmount(() => {
			scrollView.removeEventListener("scroll", handleScroll);
		});
	}
});
onBeforeUnmount(() => {
	proxy.$mitt.off("updateCart");
});

return (_ctx: any,_cache: any) => {
  const _component_NoticeDialog = _resolveComponent("NoticeDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["topContainer spaceBetween", bk.value == 'back' ? 'topbg' : bk.value == 'black' ? 'topblack' : ''])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, _toDisplayString(__props.title), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "language",
          onClick: goLanguage,
          src: _imports_0
        }),
        _createElementVNode("div", {
          class: "flexStart cartout",
          onClick: goCart
        }, [
          (!cartNumber.value)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5)),
          (cartNumber.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(cartNumber.value), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("img", {
          class: "icon",
          onClick: navigateOut,
          src: _imports_3,
          alt: ""
        })
      ]),
      (backPop.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["navigator", { 'slide-in': isOpen.value }])
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("message.mine.mine")), 1),
        _createElementVNode("div", _hoisted_11, " Hi," + _toDisplayString(phone.value), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mineList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "item commonFont",
            onClick: ($event: any) => (go(item)),
            style: {"color":"#000000"}
          }, _toDisplayString(item.name), 9, _hoisted_12))
        }), 128))
      ]),
      _createElementVNode("div", {
        class: "nvbottom",
        onClick: goHome
      }, _toDisplayString(_ctx.$t("message.newadd.handleHome")), 1)
    ], 2),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "overlay",
          onClick: close
        }))
      : _createCommentVNode("", true),
    (showDeleteDialog.value)
      ? (_openBlock(), _createBlock(_component_NoticeDialog, {
          key: 1,
          title: _ctx.$t('message.mine.tip1'),
          content: _ctx.$t('message.mine.logout1'),
          cancelText: _ctx.$t('message.mine.cancel'),
          cancel: 
				() => {
					showDeleteDialog.value = false;
				}
			,
          confirmText: _ctx.$t('message.mine.log4'),
          confirm: logout
        }, null, 8, ["title", "content", "cancelText", "cancel", "confirmText"]))
      : _createCommentVNode("", true)
  ]))
}
}

})